import React from 'react';
import { Button, Dropdown } from 'antd';
import { useTranslation } from 'react-i18next';
import {
  AppLocale,
  LOCALE_STORAGE_KEY,
  SUPPORTED_LOCALES,
} from '../../i18n/i18n';

interface Props {
  style?: React.CSSProperties;
}

const LanguageSwitcher: React.FC<Props> = ({ style }) => {
  const { i18n } = useTranslation();

  const currentLocale =
    SUPPORTED_LOCALES.find((l) => l.code === i18n.language) ||
    SUPPORTED_LOCALES[0];

  const handleLanguageChange = (code: AppLocale) => {
    i18n.changeLanguage(code);
    localStorage.setItem(LOCALE_STORAGE_KEY, code);
  };

  const menuItems = SUPPORTED_LOCALES.map((locale) => ({
    key: locale.code,
    label: `${locale.flag} ${locale.label}`,
    onClick: () => handleLanguageChange(locale.code),
  }));

  return (
    <Dropdown menu={{ items: menuItems }} placement="bottomRight" arrow>
      <Button
        type="text"
        style={{ display: 'flex', alignItems: 'center', gap: '4px', ...style }}
      >
        <span>
          {currentLocale.flag} {currentLocale.code.toUpperCase()}
        </span>
      </Button>
    </Dropdown>
  );
};

export default LanguageSwitcher;
